import {
  FormTruckLoad,
  TruckLoadApiParams,
  buildNewTruckLoad,
} from "@/models/TruckLoad";

import {
  FormIlsctlLineItem,
  IlsctlLineItemApiParams,
} from "@/models/IlsctlLineItem";
import store, { StoreActions } from "@/store";
import { JSConn } from "@/utilities/js-conn";
import api from "@/api";

const itemDetails = {
  pluralName: "truck_loads",
  singularName: "truck_load",
};

const apiParamsBuilder = (jsConn: JSConn) => {
  const formParams = jsConn.formParams as FormTruckLoad;

  const tmp = formParams.ilsctl_line_items_attributes.map(
    (item: FormIlsctlLineItem): IlsctlLineItemApiParams => {
      return {
        ...item,
      };
    },
  );

  return {
    id: jsConn.formParams.id,
    truck_load: {
      ...formParams,
      ilsctl_line_items_attributes: tmp,
    } as TruckLoadApiParams,
  };
};

async function needTruckLoads(jsConn: JSConn) {
  jsConn.apiParams = jsConn.formParams;
  return api.getItems(jsConn, itemDetails).then((jsConn: JSConn) => {
    return store.dispatch(StoreActions.loadTruckLoads, jsConn.response);
  });
}

async function needTruckLoad(jsConn: JSConn) {
  return api.getItem(jsConn, itemDetails).then((jsConn: JSConn) => {
    return store.dispatch(StoreActions.loadTruckLoad, jsConn.response);
  });
}

async function createTruckLoad(jsConn: JSConn) {
  jsConn.apiParams = apiParamsBuilder(jsConn);
  return api
    .createItem(jsConn, itemDetails)
    .then((jsConn: JSConn) => {
      return store.dispatch(StoreActions.loadTruckLoad, jsConn.response);
    })
    .catch((jsConn: JSConn) => {
      return Promise.reject(jsConn);
    });
}

async function updateTruckLoad(jsConn: JSConn) {
  jsConn.apiParams = apiParamsBuilder(jsConn);
  return api
    .updateItem(jsConn, itemDetails)
    .then((jsConn: JSConn) => {
      return store.dispatch(StoreActions.loadTruckLoad, jsConn.response);
    })
    .catch((jsConn: JSConn) => {
      return Promise.reject(jsConn);
    });
}

async function deleteTruckLoad(jsConn: JSConn) {
  jsConn.apiParams = {
    id: jsConn.formParams.id,
    truck_load: {
      ...jsConn.formParams,
    },
  };

  return api
    .deleteItem(jsConn, itemDetails)
    .then(jsConn => {
      store.dispatch(StoreActions.loadTruckLoad, buildNewTruckLoad());
      return Promise.resolve(jsConn);
    })
    .catch(jsConn => {
      return Promise.reject(jsConn);
    });
}

export const truckLoadsController = {
  needTruckLoads,
  needTruckLoad,
  createTruckLoad,
  updateTruckLoad,
  deleteTruckLoad,
};
